import React, { useState, useEffect } from "react";
// utils
import FormButton from "../../button/FormButton";
import CommonForm from "../CommonForm";
import { FormikTextInput, FormikYesOrNoInput } from "../../inputs/FormikInputs";
// functions
import { postMoneda, deleteMoneda, updateMoneda } from './MonedasFunctions';
import { handleResponse } from "../../../../services/Local-services";
// validaciones
import { formikValidation } from './MonedasFormValidaciones';
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { userCredentials, formIsOpen, rowSelected, snackbarData, formData } from '../../../../recoilState/GlobalState';

export default function MonedasForm(props) {
    const [newMoneda, setNewMoneda] = useState({});
    const [inRequest, setInRequest] = useState(false);

    const setIsOpen = useSetRecoilState(formIsOpen);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const [selected, setSelected] = useRecoilState(rowSelected);
    const credentials = useRecoilValue(userCredentials);
    const data = useRecoilValue(formData);

    const { titles, updateList, procede } = props.props;

    async function handleAction() {
        const functions = { setSnackbarInfo, setInRequest, setIsOpen, setSelected, updateList };
        if (procede === 'Deleteone') {
            const response = await deleteMoneda(credentials, selected.row, setInRequest);
            return handleResponse(response, 'Moneda eliminada exitosamente', functions);
        }
        if (procede === 'Addone') {
            const response = await postMoneda(credentials, newMoneda, setInRequest)
            return handleResponse(response, 'Moneda añadida exitosamente', functions);
        }
        if (procede === 'Editone') {
            const response = await updateMoneda(credentials, newMoneda, selected.row, setInRequest)
            return handleResponse(response, 'Moneda modificada exitosamente', functions);
        }
    };

    useEffect(() => {
        if (procede !== 'Deleteone') handleAction();
    }, [newMoneda])

    const formik = formikValidation(setNewMoneda, selected.row, titles);
    const disabled = inRequest || procede === 'Deleteone';

    return (
        <CommonForm
            onSubmit={formik.handleSubmit}
            title={data.title}
            procede={procede}
        >
            <FormikTextInput
                data={data}
                name="nombre"
                formik={formik}
                disabled={disabled}
            />
            <FormikTextInput
                data={data}
                name="codigo"
                formik={formik}
                disabled={disabled}
            />
            <FormikYesOrNoInput 
                data={data}
                name="esBase"
                formik={formik}
                disabled={disabled}
            />
            <FormButton
                inRequest={inRequest}
                handleAction={handleAction}
            />
        </CommonForm>
    );
};